import React, { Component } from 'react';
import PropTypes from 'prop-types'
import _map from 'lodash/map';
import appActions from '../../actions/AppActions'
import appStore from '../../stores/AppStore';
import { localsMessages } from '../../utility/getTemplateData'

const messages = localsMessages('common/programs');
class Programs extends Component {
	static propTypes = {
		programNames: PropTypes.array
	}

	componentDidMount() {
		appStore.on('change', this.updateView);
	}

	componentWillUnmount() {
		appStore.removeListener('change', this.updateView);
	}

	updateView = (params) => {
		this.setState({});
	}

	updateSelectedProgram = (event) => {
		appActions.updateSelectedProgram(event.target.value);
	}

	render() {
		const {
			programNames
		} = this.props;
		const selectedProgram = appStore.getSelectedProgram();

		return (
			<div className="programs text-center">
				<select
					value={selectedProgram}
					onChange={this.updateSelectedProgram}
					className="vx_form-control programs-select" id="programs"
				>
					<option key={-1} value="">{messages.programs.optional}</option>
					{
						_map(programNames, (programName, index) => {

							return (
								<option key={index} value={programName}>{programName}</option>
							)
						})
					}
				</select>
			</div>
		)
	}
}
export default Programs;



// WEBPACK FOOTER //
// ./components/programs/Programs.js